"use strict";
exports.__esModule = true;
exports.HttpErrors = exports.ServiceError = void 0;
var ServiceError;
(function (ServiceError) {
    function of(value) {
        return value.error !== undefined ? value : null;
    }
    ServiceError.of = of;
})(ServiceError = exports.ServiceError || (exports.ServiceError = {}));
var HttpErrors = /** @class */ (function () {
    function HttpErrors() {
    }
    HttpErrors.JsonExpected = {
        error: "JsonExpected",
        scope: ["HTTP"],
        level: "Internal"
    };
    HttpErrors.SerialisationError = {
        error: "SerialisationError",
        scope: ["HTTP"],
        level: "Internal"
    };
    HttpErrors.NotFound = {
        error: "NotFound",
        scope: ["HTTP"],
        level: "Internal"
    };
    return HttpErrors;
}());
exports.HttpErrors = HttpErrors;
//# sourceMappingURL=error.js.map